const actions = {
  LIST_PACIENTE: 'LIST_PACIENTE',
  LIST_PACIENTE_SELECTBOX: 'LIST_PACIENTE_SELECTBOX',
  CREATE_PACIENTE: 'CREATE_PACIENTE',
  READ_PACIENTE: 'READ_PACIENTE',
  UPDATE_PACIENTE: 'UPDATE_PACIENTE',
  DELETE_PACIENTE: 'DELETE_PACIENTE',
  CREATE_PACIENTE_FICHA_MEDICA: 'CREATE_PACIENTE_FICHA_MEDICA',
  READ_PACIENTE_FICHA_MEDICA: 'READ_PACIENTE_FICHA_MEDICA',
  LIST_PACIENTE: 'LIST_PACIENTE',
  LIST_PACIENTE_HISTORIAL: 'LIST_PACIENTE_HISTORIAL',
  PACIENTE_TOTAL_ORGANIZACION: 'PACIENTE_TOTAL_ORGANIZACION',
  CREATE_PACIENTE_SERVICIO: 'CREATE_PACIENTE_SERVICIO',
  LIST_PACIENTE_SERVICIO: 'LIST_PACIENTE_SERVICIO',

  pacienteList: data => {
    return {
      type: actions.LIST_PACIENTE,
      data,
    };
  },

  pacienteListSelectBox: data => {
    return {
      type: actions.LIST_PACIENTE_SELECTBOX,
      data,
    };
  },

  pacienteCreate: data => {
    return {
      type: actions.CREATE_PACIENTE,
      data,
    };
  },

  pacienteRead: data => {
    return {
      type: actions.READ_PACIENTE,
      data,
    };
  },

  pacienteUpdate: data => {
    return {
      type: actions.UPDATE_PACIENTE,
      data,
    };
  },

  pacienteDelete: () => {
    return {
      type: actions.DELETE_PACIENTE,
    };
  },

  pacienteFichaMedicaCreate: data => {
    return {
      type: actions.CREATE_PACIENTE_FICHA_MEDICA,
      data,
    };
  },

  pacienteFichaMedicaRead: data => {
    return {
      type: actions.READ_PACIENTE_FICHA_MEDICA,
      data,
    };
  },

  pacienteHistorialList: data => {
    return {
      type: actions.LIST_PACIENTE_HISTORIAL,
      data,
    };
  },

  pacienteTotalOrganizacion: data => {
    return {
      type: actions.PACIENTE_TOTAL_ORGANIZACION,
      data,
    };
  },

  pacienteCreateServicio: data => {
    return {
      type: actions.CREATE_PACIENTE_SERVICIO,
      data,
    };
  },

  pacienteListServicio: data => {
    return {
      type: actions.LIST_PACIENTE_SERVICIO,
      data,
    };
  },
};

export default actions;
